module.exports = __webpack_public_path__ + "img/hp-three-1.fe84f7fc.jpg";